import { createFileRoute } from '@tanstack/react-router'
import { PatientRecordEntry } from '@/features/patient-record'
import { Header } from '@/components/layout/header'
import { Main } from '@/components/layout/main'
import { Search } from '@/components/search'
import { ThemeSwitch } from '@/components/theme-switch'
import { ProfileDropdown } from '@/components/profile-dropdown'

export const Route = createFileRoute('/_authenticated/medical')({
  component: function PatientRecordPage() {
    return (
      <>
        <Header fixed>
          <Search />
          <div className='ms-auto flex items-center space-x-4'>
            <ThemeSwitch />
            <ProfileDropdown />
          </div>
        </Header>
        <Main>
          <PatientRecordEntry />
        </Main>
      </>
    )
  },
})
